import { type FC } from "react";

import styled from "@emotion/styled";
import { Unauthorized } from "@snapchat/snap-design-system";

const Container = styled.div`
    position: relative;
    display: flex;
    min-height: 100vh;
`;

export const UnauthorizedPage: FC = () => (
    <Container>
        <Unauthorized />
    </Container>
);
